import { createApp, type App, type Component, type Plugin } from 'vue';
import type { I18n } from 'vue-i18n';

import TranslationService from '@/common/modules/core/services/translation.service';
import WidgetInitializerService from '@/common/modules/core/services/widget-initializer.service';
import { parseWidgetParameters, type ConfigurationObjectExtractionConfig } from '@/common/modules/config-objects';
// import * as Sentry from "@sentry/vue";

export function mountVueApplicationToWidgets(
    vueComponent: any,
    widgetName: string,
    widgets: NodeListOf<HTMLElement>,
    widgetParameterConfiguration: ConfigurationObjectExtractionConfig,
    i18n: I18n,
    appPlugins: Array<Plugin<[]>> = [],
    components: { [key: string]: Component } = {},
    createdHook: (app: App, params: any) => void = () => {},
) {
    for (const widget of widgets) {
        const identifier = WidgetInitializerService.createIdentifier();
        const params = parseWidgetParameters(widget, widgetParameterConfiguration);

        if (widget.dataset['translations'] !== undefined) {
            TranslationService.parseAttribute(i18n, widget.dataset['translations']);
        }

        const app = createApp(vueComponent, {
            identifier,
            params,
        });

        createdHook(app, params);

        const locale = (params as any).locale || null;
        const accountToken: string = (params as any).account_token || '';
        const accountCode = accountToken ? accountToken.split('-')[0] : null;
        const accountEnv = accountToken ? accountToken.split('-')[1] : null;
        // const useSentryInstance = !import.meta.env.DEV && accountEnv !== 'dev';
        // const sentryEnvironment = import.meta.env.DEV ? 'development' : 'production';
        // const sentryDsn = useSentryInstance
        //     ? "https://cf67a78a01dffeb471842bbb2568477e@o4508015005335552.ingest.de.sentry.io/4508015007170640"
        //     : undefined;
        // const sentryIntegrations = [
        //     // Sentry.browserTracingIntegration(),
        //     // Sentry.browserProfilingIntegration(),
        //     Sentry.extraErrorDataIntegration({ depth: 10 }),
        // ];
        // const sentryReplayWidgetNamesWhiteList = ['Book', 'SearchBook'];
        //
        // // Replay only enabled in production mode + one instance + whitelisted widgets only
        // if (!import.meta.env.DEV && !Sentry.isInitialized() && sentryReplayWidgetNamesWhiteList.indexOf(widgetName) !== -1) {
        //     // sentryIntegrations.push(Sentry.replayIntegration({
        //     //     maskAllText: false,
        //     // }));
        // }
        //
        // Sentry.init({
        //     app,
        //     dsn: sentryDsn,
        //     timeout: 200,
        //     integrations: sentryIntegrations,
        //     environment: sentryEnvironment,
        //     initialScope: (scope) => {
        //         scope.setTags({
        //             widget: widgetName,
        //             locale: locale,
        //             accountCode: accountCode,
        //             accountEnv: accountEnv
        //         });
        //
        //         return scope;
        //     },
        //     // Tracing
        //     tracesSampleRate: 1.0,  //  Capture 100% of the transactions
        //     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        //     tracePropagationTargets: [/localhost/, /^https:\/\/yourserver\.io\/api/],
        //     // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        //     replaysSessionSampleRate: 0.01,
        //     // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        //     replaysOnErrorSampleRate: 1.0,
        //     // VueJS
        //     trackComponents: true,
        //     // Only send errors when they're coming from the widgets
        //     beforeSend(event) {
        //         const exceptions = event.exception;
        //
        //         if (!exceptions || !exceptions.values || exceptions.values.length === 0) {
        //             return event;
        //         }
        //
        //         for (const exception of exceptions.values) {
        //             if (
        //                 !exception.stacktrace ||
        //                 !exception.stacktrace.frames ||
        //                 exception.stacktrace.frames.length == 0
        //             ) {
        //                 continue;
        //             }
        //
        //             const firstFrame = exception.stacktrace.frames[0];
        //             if (
        //                 firstFrame?.filename &&
        //                 firstFrame.filename.startsWith('https://widgets.boekingpro.nl')
        //             ) {
        //                 return event;
        //             }
        //         }
        //
        //         return null;
        //     },
        // });

        if (widgetName === 'SearchBook' && undefined != widget.dataset['availability_context']) {
            console.warn(`${widgetName} [${widget.dataset['availability_context']}] (dataset)`, JSON.parse(JSON.stringify(widget.dataset)), params);
        } else {
            console.warn(`${widgetName} (dataset)`, JSON.parse(JSON.stringify(widget.dataset)), params);
        }

        for (const plugin of appPlugins) {
            app.use(plugin);
        }

        for (const key in components) {
            const component = components[key];
            if (component) {
                app.component(key, component);
            }
        }

        app.mount(widget);
    }
}
